export const grid = ({ theme: { dimensions } }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridColumnGap: 50,
    gridRowGap: dimensions.inputRowGap,
    maxWidth: 700,
    marginTop: 65,
    marginBottom: 80,
});
